import type { RouteObject } from 'react-router';
import { TrustedSitesPage } from '@/pages/TrustedSitesPage';

export const siteRoutes: RouteObject[] = [{ path: 'trusted-sites', element: <TrustedSitesPage /> }];
